import React from 'react'
import PropTypes from 'prop-types'
import { orderBy } from 'lodash'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import Textarea from '../../../../components/forms/Textarea'
import moment from 'moment'
import DtoMaterielSituation from '../../../../materiel/dto/DtoMaterielSituation'
import DtoMaterielState from '../../../../materiel/dto/DtoMaterielState'
import Select from '../../../../components/forms/Select'
import {
    MATERIEL_STATE_ON_SITE_ID,
    MATERIEL_STATE_PROVISIONAL_ID,
    MATERIEL_STATE_TRANSFERT_ID,
} from '../../../../materiel/constants/MaterielStateConstants'
import Checkbox from '../../../../components/forms/Checkbox'
import { Alert, Grid } from '@mui/material'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import { SHOW_SANDRE_CODE } from 'account/constants/AccountSettingsConstants'
import useApplicationSetting from 'utils/customHook/useApplicationSetting'
import useAccountSetting from 'utils/customHook/useAccountSetting'

const SituationStationForm = ({
    situation = {},
    materialState = [],
    materiels = [],
    idKey = '',
    isLast = false,
    isEditMode = false,
    materielsOnSite = [],
    shouldReplace = false,
    newMaterielSituation = {},
    changeValue = () => { },
    onChangeNewMaterielSituation = () => { },
}) => {
    const generalShowSandreCode = useApplicationSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : true)
    const showSandreCode = useAccountSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : generalShowSandreCode)

    const hasNoSelectableMateriel = !materiels.length && !situation[idKey]

    const getSelectSituationState = (() => {
        if (situation.situationEndDate) {
            const filterState = materialState.filter(o => o.id !== MATERIEL_STATE_ON_SITE_ID && o.id !== MATERIEL_STATE_TRANSFERT_ID && o.id !== MATERIEL_STATE_PROVISIONAL_ID)
            const datas = orderBy(filterState.map(o => ({
                id: o.code,
                name: o.label,
            })), 'id', 'asc')
            return (
                <Grid size={3}>
                    <Select
                        options={datas}
                        label={i18n.state}
                        onChange={v => changeValue('statusCode', parseInt(v))}
                        value={situation.statusCode}
                        nullLabel='&nbsp;'
                    />
                </Grid>
            )
        }
        return null
    })()
    return (
        <Grid container columnSpacing={2} alignItems='center'>
            <Grid size={5}>
                {
                    hasNoSelectableMateriel && (
                        <Alert severity='info' sx={{ fontSize: '1rem', lineHeight: 'inherit', paddingY: '0.1rem' }}>
                            {i18n.noMaterial}
                        </Alert>
                    ) || (
                        <Select
                            value={situation[idKey]}
                            label={i18n.materiel}
                            options={materiels}
                            displayWithCode={showSandreCode}
                            keyValue={'id'}
                            disabled={situation.id || !isEditMode}
                            onChange={value => {
                                if (!value) {
                                    if (situation.siteCode) {
                                        changeValue(idKey, '')
                                    }
                                } else {
                                    changeValue(idKey, value)
                                }
                            }}
                        />
                    )
                }
            </Grid>
            <Grid size={3}>
                <SimpleDatePicker
                    onChange={(v) => changeValue('situationDate', +moment(v))}
                    id='situationDate'
                    title={i18n.creationDate}
                    value={situation.situationDate}
                    disabled={situation.id || !isEditMode}
                />
            </Grid>
            {
                (situation.id || !isEditMode) && (
                    <Grid size={3}>
                        <SimpleDatePicker
                            onChange={(v) => changeValue('situationEndDate', +moment(v))}
                            id='situationEndDate'
                            disabled={isLast || !isEditMode}
                            title={i18n.endDate}
                            value={situation.situationEndDate}
                        />
                    </Grid>
                )
            }
            {getSelectSituationState}
            <Grid size={12}>
                <Textarea
                    title={i18n.comment}
                    value={situation.comment}
                    onChange={v => changeValue('comment', v)}
                    disabled={!isEditMode}
                />
            </Grid>
            {
                !!materielsOnSite.length && !situation.id && (
                    <Grid container size={12} alignItems='center' sx={{ paddingTop: '0.625rem' }}>
                        <Grid size={4}>
                            <Checkbox
                                label={i18n.replaceMaterial}
                                checked={shouldReplace}
                                onChange={v => onChangeNewMaterielSituation({
                                    shouldReplace: v,
                                    newMaterielSituation: {},
                                })}
                                disabled={!isEditMode}
                            />
                        </Grid>
                        {
                            shouldReplace && (
                                <Grid size={4}>
                                    <Select
                                        options={materielsOnSite}
                                        label={i18n.materialToReplace}
                                        onChange={v => onChangeNewMaterielSituation({
                                            newMaterielSituation: { [idKey]: v },
                                        })}
                                        value={newMaterielSituation[idKey]}
                                        nullLabel='&nbsp;'
                                        disabled={!isEditMode}
                                    />
                                </Grid>
                            )
                        }
                        {
                            !!newMaterielSituation[idKey] && (
                                <Grid size={4}>
                                    <Select
                                        options={materialState.filter(s => s.code !== 1 && s.code !== 4)}
                                        label={i18n.newSituation}
                                        onChange={v => onChangeNewMaterielSituation({
                                            newMaterielSituation: {
                                                ...newMaterielSituation,
                                                statusCode: v,
                                            },
                                        })}
                                        value={newMaterielSituation.statusCode}
                                        nullLabel='&nbsp;'
                                        disabled={!isEditMode}
                                    />
                                </Grid>
                            )
                        }
                    </Grid>
                )
            }
        </Grid>
    )
}

SituationStationForm.propTypes = {
    materialState: PropTypes.arrayOf(PropTypes.instanceOf(DtoMaterielState)),
    situation: PropTypes.instanceOf(DtoMaterielSituation),
    materiels: PropTypes.arrayOf(PropTypes.object),
    isLast: PropTypes.bool,
    changeValue: PropTypes.func,
    idKey: PropTypes.string,
    isEditMode: PropTypes.bool,
    materielsOnSite: PropTypes.array,
    shouldReplace: PropTypes.bool,
    newMaterielSituation: PropTypes.object,
    onChangeNewMaterielSituation: PropTypes.func,
}

const mapStateToProps = store => ({
    materialState: store.MaterielReducer.materielStates,
})

export default connect(mapStateToProps)(SituationStationForm)
